export default {
  common: {
    siteName: "Kakobuy Polska Spreadsheet",
    siteTagline: "Niezależny przewodnik Kakobuy Spreadsheet dla polskich użytkowników",
  },
  nav: {
    home: "Strona główna",
    categories: "Kategorie",
    articles: "Artykuły",
    spreadsheet: "Spreadsheet",
    guide: "Poradnik",
    safety: "Bezpieczeństwo",
    faq: "FAQ",
  },
  hero: {
    title: "Kakobuy Spreadsheet Polska – Największa baza produktów i najlepszych Finds",
    subtitle: "Znajdź tysiące produktów Kakobuy w jednym miejscu. Nasza lista Spreadsheet pomaga szybciej odkrywać najlepsze produkty, porównywać opcje i podejmować lepsze decyzje zakupowe.",
    ctaPrimary: "Przeglądaj Kakobuy Spreadsheet",
    ctaSecondary: "Kup teraz",
    trustBadge1: "Aktualizowane listy produktów",
    trustBadge2: "Szczegółowe poradniki",
    trustBadge3: "Porównania produktów",
    trustBadge4: "Bezpieczeństwo zakupów",
  },
  categories: {
    title: "Przeglądaj kategorie produktów",
    subtitle: "Wybierz kategorię i odkryj najlepsze produkty Kakobuy",
    dropdownLabel: "Wybierz kategorię",
  },
  article: {
    title: "Artykuły i poradniki Kakobuy",
    subtitle: "Poznaj nasze szczegółowe przewodniki i porady zakupowe",
    readMore: "Czytaj więcej",
  },
  cta: {
    title: "Gotowy na zakupy z Kakobuy?",
    subtitle: "Uzyskaj dostęp do pełnego Kakobuy Spreadsheet i znajdź najlepsze produkty już dziś.",
    button: "Otwórz Kakobuy Spreadsheet",
  },
  footer: {
    copyright: "© 2026 Kakobuy Polska Spreadsheet. Wszelkie prawa zastrzeżone.",
    disclaimer: "Kakobuy Polska Spreadsheet jest niezależnym przewodnikiem. Nie jesteśmy powiązani z Kakobuy.",
  },
};